<template>
  <v-col cols="12" v-if="admin || temEndereco">
    <v-card outlined class="pa-4">
      <h3 class="text-subtitle-1 font-weight-bold mb-2">
        {{ $t("Oportunidades_Portais_de_oportunidades") }}
      </h3>
      <p class="text-body-2 grey--text">
        {{
          $t(
            "Oportunidades_Registre_os_enderecos_oficiais_de_licitacoes_e_chamamentos_deste_local_A_pesquisa_inicial_preserva_os_enderecos_ja_preenchidos"
          )
        }}
      </p>
      <v-alert v-if="value && value.mensagemPortais" type="info" text>{{
        value.mensagemPortais
      }}</v-alert>
      <div v-for="grupo in grupos" :key="grupo.oficial">
        <h4
          v-if="grupo.titulo"
          class="text-subtitle-2 font-weight-bold mt-2 mb-3"
        >
          {{ grupo.titulo }}
        </h4>
        <v-text-field
          :value="campo(grupo.oficial)"
          @input="alterar(grupo.oficial, $event)"
          :label="grupo.rotuloOficial"
          outlined
          dense
          :readonly="!admin"
          :rules="[urlValida]"
          maxlength="2000"
        />
        <v-row>
          <v-col v-for="tipo in grupo.tipos" :key="tipo.url" cols="12" md="6">
            <v-text-field
              :value="campo(tipo.url)"
              @input="alterar(tipo.url, $event)"
              :label="tipo.label"
              outlined
              dense
              :readonly="!admin"
              :rules="[urlValida]"
              maxlength="2000"
            />
            <v-checkbox
              :input-value="campo(tipo.ativo) === true"
              @change="alterar(tipo.ativo, $event)"
              :label="$t('Oportunidades_Consultar_diariamente')"
              :disabled="!admin || !campo(tipo.url)"
              dense
            />
            <v-expansion-panels v-if="admin" flat>
              <v-expansion-panel
                ><v-expansion-panel-header>
                  {{ $t("Oportunidades_Configuracao_de_leitura_do_portal") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="text-caption">
                    {{
                      $t(
                        "Oportunidades_Configure_os_detalhes_a_paginacao_e_os_documentos_antes_de_habilitar_a_consulta_diaria"
                      )
                    }}
                  </p>
                  <v-textarea
                    :value="campo(tipo.config)"
                    @input="alterar(tipo.config, $event)"
                    :label="$t('Oportunidades_Configuracao_JSON')"
                    outlined
                    rows="5"
                    :rules="[jsonValido]"
                    maxlength="20000"
                  /> </v-expansion-panel-content
              ></v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-col>
</template>
<script>
import {
  podeOportunidades,
  urlOficial,
  mensagemOportunidade,
} from "@/utils/oportunidadesPublicas";
export default {
  name: "CamposPortaisOportunidades",
  props: {
    value: { type: Object, default: null },
    // Define o órgão do Legislativo: câmara municipal, assembleia ou congresso.
    local: { type: String, default: "Cidade" },
  },
  data() {
    return {};
  },
  computed: {
    grupos() {
      return [
        {
          oficial: "portalOficial",
          rotuloOficial: this.$t("Oportunidades_Portal_oficial"),
          tipos: this.tipos,
        },
        {
          titulo: this.$t(
            this.local === "Estado"
              ? "Oportunidades_Assembleia_legislativa"
              : this.local === "Pais"
              ? "Oportunidades_Congresso_nacional"
              : "Oportunidades_Camara_municipal"
          ),
          oficial: "portalLegislativo",
          rotuloOficial: this.$t("Oportunidades_Site_oficial_do_Legislativo"),
          tipos: [
            {
              url: "portalLicitacoesLegislativo",
              ativo: "coletarLicitacoesLegislativo",
              config: "configuracaoLicitacoesLegislativo",
              label: this.$t(
                "Oportunidades_Portal_de_licitacoes_do_Legislativo"
              ),
            },
          ],
        },
      ];
    },
    tipos() {
      return [
        {
          url: "portalLicitacoes",
          ativo: "coletarLicitacoes",
          config: "configuracaoLicitacoes",
          label: this.$t("Oportunidades_Portal_de_licitacoes"),
        },
        {
          url: "portalChamamentos",
          ativo: "coletarChamamentos",
          config: "configuracaoChamamentos",
          label: this.$t("Oportunidades_Portal_de_chamamentos"),
        },
      ];
    },

    admin() {
      return podeOportunidades(this.$store.state, "Admin");
    },
    temEndereco() {
      return !!(
        this.value?.portalOficial ||
        this.value?.portalLicitacoes ||
        this.value?.portalChamamentos ||
        this.value?.portalLegislativo ||
        this.value?.portalLicitacoesLegislativo
      );
    },
  },
  methods: {
    mensagemFonte: mensagemOportunidade,
    campo(nome) {
      return this.value?.[nome] ?? null;
    },
    alterar(nome, valor) {
      this.$emit("input", { ...this.value, [nome]: valor });
    },
    urlValida(v) {
      return (
        !v ||
        !!urlOficial(v) ||
        this.$t("Oportunidades_Informe_uma_URL_HTTP_S_valida")
      );
    },
    jsonValido(v) {
      try {
        if (!v) return true;
        const j = JSON.parse(v);
        return (
          (j && !Array.isArray(j) && typeof j === "object") ||
          this.$t("Oportunidades_Informe_um_objeto_JSON")
        );
      } catch {
        return this.$t("Oportunidades_JSON_invalido");
      }
    },
  },
};
</script>
